/**
 * Firebase client config – BarChain project.
 * Used by auth, firestore, storage, analytics. No app logic here.
 */
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, httpsCallable } from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyB6b9cUVC5np_rD4AQihty5WOr6b-oKP7E',
  authDomain: 'barchain-24c66.firebaseapp.com',
  projectId: 'barchain-24c66',
  storageBucket: 'barchain-24c66.firebasestorage.app',
  messagingSenderId: '901948900179',
  appId: '1:901948900179:web:2a2e59abbc0b8589ead7a6',
  measurementId: 'G-R8X45D8N7Y',
};

export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

export function getResetWorkoutVerificationsCallable() {
  return httpsCallable(functions, 'resetWorkoutVerifications');
}
